
  document.addEventListener("DOMContentLoaded", function () {
    const containers = document.querySelectorAll('.image-with-text--content .rte');
    const revealItems = [];

    containers.forEach(container => {
      const paragraphs = container.querySelectorAll('p');
      container.innerHTML = ''; // Clear existing content

      paragraphs.forEach((p, index) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'reveal-p';
        wrapper.dataset.delay = index * 150;
        wrapper.appendChild(p);
        container.appendChild(wrapper);
        revealItems.push(wrapper); // Save for observer
      });
    });

    let lastScrollY = window.scrollY;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const el = entry.target;
        const delay = Number(el.dataset.delay) || 0;
        const scrollingDown = window.scrollY > lastScrollY;
        lastScrollY = window.scrollY;

        el.classList.remove('enter', 'exit');

        if (entry.isIntersecting) {
          setTimeout(() => el.classList.add('enter'), delay);
        } else {
          el.classList.add('exit');
        }
      });
    }, { threshold: 0.4 });

    revealItems.forEach(el => observer.observe(el));
  });




document.addEventListener("DOMContentLoaded", function () {
  const popupBtn = document.querySelector(".mobile-toggle-wrapper");
  const closeBtn = document.querySelector(".mobile-toggle-wrapper.active");

  function openPopup() {
    document.body.classList.add("js-drawer-open");
  }

  function closePopup() {
    document.body.classList.remove("js-drawer-open");

    setTimeout(() => {
      popup.classList.remove("closing");
    }, 400);
  }

  if (popupBtn) popupBtn.addEventListener("click", openPopup);
  if (closeBtn) closeBtn.addEventListener("click", closePopup);
});


